import React from 'react';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { all_routes } from '../../router/all_routes';
import Pagination from './Pagination';
// import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb';

const BlogGrid3 = () => {
  const blogList = [
    {
      id: 1,
      category: 'Education',
      title: 'Learn Web App Development from Experts in 2024',
      description: 'Master the art of web application development with expert-led courses that cover the latest tools, fram...',
      image: './assets/img/blog/blog-7.jpg',
      author: {
        name: 'John Miller',
        image: './assets/img/user/user-52.jpg',
      },
      date: '23 Apr 2024',
    },
    {
      id: 2,
      category: 'Guides',
      title: 'Expand Your Career Opportunities With Python',
      description: 'Unlock limitless career opportunities by mastering Python, one of the most versatile and in-demand ...',
      image: './assets/img/blog/blog-8.jpg',
      author: {
        name: 'Cedric Glenn',
        image: './assets/img/user/user-01.jpg',
      },
      date: '20 Apr 2024',
    },
    {
      id: 3,
      category: 'Technical',
      title: 'Learn Mobile Applications Development from Experts',
      description: 'Elevate your skills with expert-led training in mobile application development! Learn to design, develop ...',
      image: './assets/img/blog/blog-9.jpg',
      author: {
        name: 'John Reyes',
        image: './assets/img/user/user-02.jpg',
      },
      date: '04 Apr 2024',
    },
    {
      id: 4,
      category: 'Guides',
      title: 'Complete PHP Programming Career Guideline',
      description: 'Master PHP programming with our comprehensive career guideline! Learn the fundamentals, explore ...',
      image: './assets/img/blog/blog-10.jpg',
      author: {
        name: 'Donald Vesely',
        image: './assets/img/user/user-03.jpg',
      },
      date: '24 Mar 2024',
    },
    {
      id: 5,
      category: 'Education',
      title: 'The Complete JavaScript Course for Beginners',
      description: 'Dive into the world of JavaScript with our complete beginner-friendly course! Learn essential concepts...',
      image: './assets/img/blog/blog-11.jpg',
      author: {
        name: 'Richard Garza',
        image: './assets/img/user/user-05.jpg',
      },
      date: '16 Mar 2024',
    },
    {
      id: 6,
      category: 'Guides',
      title: 'Programming Content Guideline For Beginners',
      description: 'Kickstart your programming journey with beginner-friendly guidelines designed to simplify coding ...',
      image: './assets/img/blog/blog-12.jpg',
      author: {
        name: 'Lewis Devine',
        image: './assets/img/user/user-06.jpg',
      },
      date: '10 Mar 2024',
    },
    {
      id: 7,
      category: 'Feature',
      title: 'Revolutionize Learning with a Modern LMS',
      description: 'Discover how a Learning Management System (LMS) can transform education and corporate training by ...',
      image: './assets/img/blog/blog-13.jpg',
      author: {
        name: 'James Barnes',
        image: './assets/img/user/user-07.jpg',
      },
      date: '23 Feb 2024',
    },
    {
      id: 8,
      category: 'Education',
      title: 'Revolutionize Learning with a Modern LMS',
      description: 'An LMS streamlines training and development with centralized resources, progress tracking, and flexible..',
      image: './assets/img/blog/blog-14.jpg',
      author: {
        name: 'Francis Bishop',
        image: './assets/img/user/user-08.jpg',
      },
      date: '20 Feb 2024',
    },
    {
      id: 9,
      category: 'Feature',
      title: 'Transform Education with the Power of an LMS',
      description: 'Explore how an LMS creates engaging, personalized learning experiences while simplifying course ...',
      image: './assets/img/blog/blog-15.jpg',
      author: {
        name: 'Cesar Wilson',
        image: './assets/img/user/user-09.jpg',
      },
      date: '10 Feb 2024',
    },
  ];

  return (
    <>
      {/* <Breadcrumb title='Blog 3 Grid' /> */}
      <div className="content" data-aos="zoom-in">
        <div className="container">
          <div className="row">
            {blogList.map((blog) => (
              <div className="col-xl-4 col-md-6" key={blog.id}>
                <div className="blog">
                  <div className="blog-image">
                    <Link to={all_routes.newsandArticlesDetails}>
                      <ImageWithBasePath className="img-fluid" src={blog.image} alt="img" />
                    </Link>
                  </div>
                  <div className="blog-item">
                    <span className="badge bg-[#EA1D2A] mb-2">{blog.category}</span>
                    <h5 className="mb-2">
                      <Link to={all_routes.newsandArticlesDetails}>{blog.title}</Link>
                    </h5>
                    <p className="text-truncate line-clamb-2">{blog.description}</p>
                    <div className="blog-info">
                      <div className="d-flex align-items-center flex-wrap justify-content-between gap-2">
                        <div className="d-flex align-items-center user-profile">
                          {/* <Link to={all_routes.instructorDetails} className="user-img">
                            <ImageWithBasePath className="rounded-pill w-auto" src={blog.author.image} alt="img" />
                          </Link> */}
                          {/* <Link to={all_routes.instructorDetails} className="user-name">
                            {blog.author.name}
                          </Link> */}
                        </div>
                        <ul className="d-flex align-items-center flex-wrap gap-2">
                          <li>
                            <ImageWithBasePath className="me-1" src="./assets/img/icons/calendar.svg" alt="img" />
                            <p>{blog.date}</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="flex flex-col justify-center items-center p-4">
                <Pagination />
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default BlogGrid3;
